import allRoutes from "../routes";

export default function getFilteredRoutes() {
  const alwaysInclude = ["dashboard", "sign in", "sign up"];
  const stored = sessionStorage.getItem("modulefunctions");

  if (!stored) {
    return allRoutes.filter((route) => alwaysInclude.includes(route.name?.toLowerCase()));
  }
  const moduleFunctions = JSON.parse(stored);
  const allowedModules = moduleFunctions.map((mod) => mod.module_name.toLowerCase());
  //console.log("allowed modules", allowedModules);
  // Combine alwaysIncluded with allowedModules
  const validModules = [...new Set([...allowedModules, ...alwaysInclude])];
  //console.log("valid modules", allowedModules);
  const filteredRoutes = allRoutes.filter((route) =>
    validModules.includes(route.name?.toLowerCase())
  );
  //console.log("filter", filteredRoutes);
  return filteredRoutes;
}
